import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["body", "collapseIcon"];

  connect() {
    this.toggleBody = this.toggleBody.bind(this);
    this.element.addEventListener("click", this.toggleBody);
  }

  disconnect() {
    this.element.removeEventListener("click", this.toggleBody);
  }

  toggleBody(event) {
    if (event.target.closest(".card-header")) {
      this.bodyTarget.classList.toggle("hidden");
      this.collapseIconTarget.classList.toggle("rotate-180");
    }
  }
}
